import { ECheckedValue } from "library/types/types";

export const APP_ID = 900000000009959;
export const APP_SETTING_ID = 900000000010304;
export const ROUTES = {
  HOME: "/",
  UNAUTHORIZED_PAGE: "/unauthorized",
  OFFER: "/offer",
  OFFERS: "/offer",
  FORM_PAGE: "/form-page",
  FORM_PAGE_NEW: "/form-page/new",
  ITEM_PAGE: "/item-page",
  ITEM_PAGE_DETAIL: "/item-page/:itemId",
};

export const breakpoints = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export const devices = {
  xs: `(min-width: ${breakpoints.xs}px)`,
  sm: `(min-width: ${breakpoints.sm}px)`,
  md: `(min-width: ${breakpoints.md}px)`,
  lg: `(min-width: ${breakpoints.lg}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
  "2xl": `(min-width: ${breakpoints["2xl"]}px)`,
};

export const checkedOptions = [
  {
    value: ECheckedValue.Yes,
    label: "Yes",
    text: "Yes",
  },
  {
    value: ECheckedValue.No,
    label: "No",
    text: "No",
  },
];

export const LOCATION_STATES = {
  PREV_PATH_NAME: "previousLocationPathname",
};

export const hexColorPalette = [
  "#F0E5D7",
  "#C7CBBD",
  "#C5D7D1",
  "#FAEDCD",
  "#9FAEA9",
];
